import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResourceService } from './resource.service';

@Injectable()
export class BackendService {
  constructor(private backendResourceService: ResourceService<boolean>) {}

  getOffHours$(): Observable<boolean> {
    return this.backendResourceService.get(`backend/off-hours`);
  }
}
